import React from "react";
import S from './Agreement.module.scss';

export const Agreement = () => {
  return (
    <div className={S.root}>
      <div className={S.elements}>
        <h1>Согласие на обработку<br/> персональных данных</h1>
        <div className={S.text}>
          <p>Физическое лицо, оставляя заявку на веб-сайте https://bmc-soft.ru, нажимая на кнопку
            «Отправить», действуя свободно, своей волей и в своем интересе, а также подтверждая свою
            дееспособность, предоставляет свое согласие на обработку персональных данных (далее —
            Согласие) ООО «БМК-СОФТ» (ИНН 4400022528, КПП 440001001, ОГРН 1244400004672), которому
            принадлежит веб-сайт https://bmc-soft.ru, и которое зарегистрировано по адресу: Россия,
            156000, г. Кострома, ул. Смоленская, д. 12, кв. 3, на обработку своих персональных данных со
            следующими условиями:
          </p>
          <div className={S.paragraph}>
            <p className={S.number}>1.</p>
            <p className={S.paragraphText}>Данное Согласие дается на обработку персональных данных, как без
              использования средств
              автоматизации, так и с их использованием.</p>
          </div>
          <div className={S.paragraph}>
            <p className={S.number}>2.</p>
            <p className={S.paragraphText}>Согласие дается на обработку следующих моих персональных данных: персональные
              данные, не
              относящиеся к специальной категории персональных данных или к биометрическим
              персональным
              данным: фамилия, имя, e-mail, номер телефона, название организации; любая информация
              указанная мной в формах сайта.</p>
          </div>
          <div className={S.paragraph}>
            <p className={S.number}>3.</p>
            <p className={S.paragraphText}>Цель обработки персональных данных: обработка входящих заявок и
              предоставление
              консультаций.</p>
          </div>
          <div className={S.paragraph}>
            <p className={S.number}>4.</p>
            <p className={S.paragraphText}>В ходе обработки с персональными данными будут совершены следующие действия:
              сбор;
              запись;
              систематизация; накопление; хранение; уточнение (обновление, изменение); передача
              третьим
              лицам в рамках исполнения договоров и соблюдения требований законодательства;
              извлечение;
              использование; блокирование; удаление; уничтожение.</p>
          </div>
          <div className={S.paragraph}>
            <p className={S.number}>5.</p>
            <p className={S.paragraphText}>Согласие действует с момента его предоставления и до момента его отзыва, за
              исключением
              случаев, когда иной срок установлен действующим законодательством.</p>
          </div>
          <div className={S.paragraph}>
            <p className={S.number}>6.</p>
            <p className={S.paragraphText}>Согласие может быть отозвано вами или вашим представителем путем направления
              в ООО
              «БМК-СОФТ» письменного заявления или электронного заявления по адресу, указанному в
              начале
              Согласия.</p>
          </div>
          <div className={S.paragraph}>
            <p className={S.number}>7.</p>
            <p className={S.paragraphText}>В случае отзыва Согласия Оператор вправе продолжить обработку персональных
              данных без
              него
              при наличии оснований, указанных в пунктах 2 — 11 части 1 статьи 6, части 2 статьи 10 и
              части 2 статьи 11 Федерального закона №152-ФЗ «О персональных данных» от 27.07.2006
              г.</p>
          </div>
        </div>
      </div>
    </div>
  );
};